export default __webpack_public_path__ + "static/Smartcontract_logo-92433eb2949282d8468f8ce9d108ef20.png";